import React, { type SelectHTMLAttributes } from "react";

import { Select, type SelectProps } from "../Select";
import { states } from "./states";

type AcceptedCountryCode = "US" | "CA" | "IN" | "BR";

export const StateSelect = React.forwardRef<
  HTMLSelectElement,
  Omit<SelectHTMLAttributes<HTMLSelectElement> & SelectProps, "children"> & {
    countryCode: AcceptedCountryCode;
  }
>(({ countryCode, ...attrs }, ref) => (
  <Select key={countryCode} {...attrs} ref={ref} defaultValue={attrs.defaultValue ?? ""}>
    <option value="" disabled>
      State
    </option>
    {states[countryCode].map((state) => (
      <option key={state.code} value={state.code}>
        {state.name}
      </option>
    ))}
  </Select>
));

StateSelect.displayName = "StateSelect";
